import { useRouter } from "next/router";

import { reportAddToBagStats } from "api/requests/reportAtbStats";

type dataDogStatsBagAreaType = {
  [key: string]: string;
};

type statsType = {
  atbAction?: boolean;
  atbError?: boolean;
};

// grab bag area location for DataDog reporting
const dataDogStatsBagArea: dataDogStatsBagAreaType = {
  "/dispensary-info/[slug]": "dispensary",
  "/dispensary-info/[slug]/deals": "dispensary",
  "/dispensary-info/[slug]/menu": "dispensary",
  "/dispensary-info/[slug]/p/[menuItem]/[productSlug]": "pdp",
  "/search/shop": "shop-modal",
};

export const useATBStats = () => {
  const { pathname } = useRouter();

  return {
    reportATBStats: (stats: statsType) =>
      reportAddToBagStats(dataDogStatsBagArea[pathname], stats),
  };
};
